export const LoanTermEnum = {
    ThirtyYear: "30 Year",
    TwentyFiveYear: "25 Year",
    TwentyYear: "20 Year",
    FifteenYear: "15 Year",
    TenYear: "10 Year"
};

export const LoanType = {
    Conventional: "Conventional",
    Conforming: "Conventional",
    NonConforming: "Portfolio",
    FHA: "FHA",
    VA: "VA"
};

export const NumberOfUnits = {
    1:"OneUnit",
    2:"TwoUnits",
    3:"ThreeUnits",
    4:"FourUnits"
}

 const BACKEND_URL=process.env.REACT_APP_BACKEND_URL

export const apiEndpoints={
    CREATE_SESSION:`${BACKEND_URL}/createSession`,
    CREATE_APPLICATION:`${BACKEND_URL}/createApplication`,
    SAVESTEP:`${BACKEND_URL}/saveStep`
    };
    export const appointmentApiEndpoints = {
  GET_APPOINTMENTS: `${BACKEND_URL}/getAppointments`,
  BOOK_APPOINTMENT: `${BACKEND_URL}/bookAppointments`,
};
export const crmLeadCreate={
    CREATE_LEAD: `${BACKEND_URL}/crm-create-lead`
};
export const contactApiEndpoints = {
  ASSIGN_CONTACT: `${BACKEND_URL}/crm-lead-assign`,
};

export const leadAssignApiEndpoints={
    ADDRESS_ENDPOINT : `${BACKEND_URL}/places/address`,
    CITES_ENDPOINT: `${BACKEND_URL}/places/cities`,
    PLACES_ENDPOINT: `${BACKEND_URL}/places/details`
}

export const API_URL = process.env.REACT_APP_CREATE_CUSTOMER_SERVER_URL;

